import { EBlockchain } from 'multirpc-sdk';

import { ECurrency, TCryptoCurrency } from 'modules/payments/types';

import { NetworkIcon } from '../NetworkIcon';
import { TokenIcon } from '../TokenIcon';
import { useCurrencyIconStyles } from './useCurrencyIconStyles';

type Classes = ReturnType<typeof useCurrencyIconStyles>['classes'];

interface ICurrencyIconProps {
  className?: string;
  currency: ECurrency;
  network?: EBlockchain;
  classes?: Partial<Classes>;
}

export const CurrencyIcon = ({
  className,
  classes: classesProp,
  currency,
  network,
}: ICurrencyIconProps) => {
  const { classes, cx } = useCurrencyIconStyles();

  return (
    <div className={cx(classes.root, className || classesProp?.root)}>
      <TokenIcon
        token={currency as TCryptoCurrency}
        className={cx(classes.currencyIcon, classesProp?.currencyIcon)}
      />

      {network && (
        <NetworkIcon
          network={network}
          className={cx(classes.networkIcon, classesProp?.networkIcon)}
        />
      )}
    </div>
  );
};
